import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { getHomePageContent } from 'redux/actions/Entry'


interface Card {
    children?: Element;
    title?: string;
    noTitle?: boolean;
    actions?: boolean;
}

function HighlightCard(props: any) {

    const { children, title, noTitle, actions } = props;
    const [homePageContent, setHomePageContent] :any = useState("Welcome to the Entry Management System (EMS) of the PropertyGuru Asia Property Awards. You can use the EMS to create a user account that allows you to enter all of the Asia Property Awards in the countries of your choice. Please take a moment to complete the registration form below. \n Once active you can use EMS to create and submit unlimited entries in the categories of your choice. You will be able to start entries and return to complete them later, upload photos and video and download entries as PDFs for offline viewing. If you have any problems, please email awards@propertyguru.com")

    useEffect(() => {
        props.getHomePageContent({role: 1}).then((res: any) => {
          if(res?.welcome?.description){
            setHomePageContent(res.welcome.description)
          }
        })
      }, [])

    return (
        <div className="card-cotainer mt-8">
            <div className="highlight-card align-items">
                {!noTitle && <h1 className="title">
                    {title}
                </h1>}
                {/* {children} */}
                {homePageContent ? <p style={{whiteSpace: 'pre-line'}} className="content-1 mb">{homePageContent}</p> : 
                <>
                <p className="content-1 mb">
                    Welcome to the Entry Management System (EMS) of the PropertyGuru Asia Property Awards. You can use the EMS to create a user account that allows you to enter all of the Asia Property Awards in the countries of your choice. Please take a moment to complete the registration form below.
                </p>
                <p className="content-2">
                    Once active you can use EMS to create and submit unlimited entries in the categories of your choice. You will be able to start entries and return to complete them later, upload photos and video and download entries as PDFs for offline viewing. If you have any problems, please email awards@propertyguru.com
                </p>
            </>}
                
            </div>
            {actions && <div className="d-flex mt-3  align-items flex-wrap">
               <Link to="/login" > <button className="btn btn-sm btn-primary me-md-3">
                    Existing user? Click here
                </button>
                </Link>
                <Link to="/signup"  className="text-dark btn btn-sm btn-link">   <u>New user? Click here</u> </Link>
            </div>}
        </div>
    )
}


function DefaultContent() {
    return (
        <>
            <p className="content-1 mb">
                Welcome to the Entry Management System (EMS) of the PropertyGuru Asia Property Awards. You can use the EMS to create a user account that allows you to enter all of the Asia Property Awards in the countries of your choice. Please take a moment to complete the registration form below.
            </p>
            <p className="content-2">
                Once active you can use EMS to create and submit unlimited entries in the categories of your choice. You will be able to start entries and return to complete them later, upload photos and video and download entries as PDFs for offline viewing. If you have any problems, please email awards@propertyguru.com
            </p>
        </>
    )
}

HighlightCard.defaultProps = {
    title: `THE ULTIMATE HALLMARK OF EXCELLENCE IN ASIAN REAL ESTATE`,
    children: <DefaultContent />,
    actions: true
}

const mapDispatchToProps = {
    getHomePageContent
  };
  

  export default connect(null, mapDispatchToProps)(HighlightCard);